import { makeStyles, createStyles, Paper } from "@material-ui/core";
import React from "react";
import { Resolver } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { PERMISSIONS } from "../../../const/permissions.const";
import useCheckPermissions from "../../../hooks/useCheckPermissions";
import { FormPermissions } from "../../../Permissions";
import { IReduxAppState } from "../../../reducers";
import DynamicForm from "../../../yoello-lib/modules/dynamicForms/DynamicForms";
import FormTitle from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTitle";
import EColourPanel from "../../../yoello-lib/modules/dynamicForms/interfaces/EColourPanel";
import IDynamicFormRow from "../../../yoello-lib/modules/dynamicForms/interfaces/IDynamicFormRow";
import { IYoelloTheme } from "../../../yoello-lib/modules/themes/IYoelloTheme";

const useStyles = makeStyles((theme: IYoelloTheme) =>
    createStyles({
        leftButtonCustomClassName: {
            justifyContent: "unset!important",
            marginTop: "1.75rem",
            "& button": {
                width: "unset!important"
            }
        },
        rightButtonCustomClassName: {
            flexBasis: "0!important",
            display: "none!important"
        }
    }),
);

interface IPickupForms {
    formData: any;
    handleSubmit: (data: unknown) => void;
    formRows: IDynamicFormRow[];
    formButtonText?: string;
    isLoading: boolean;
    title?: string;
    subTitle?: string;
    resolver?: Resolver<any, any>;
}
export function PickupForms({ formData, handleSubmit, formRows, formButtonText, isLoading, title, subTitle, resolver }: IPickupForms) {
    const subscription = useSelector((state: IReduxAppState) => state.subscription);
    const { rightButtonCustomClassName, leftButtonCustomClassName } = useStyles();

    const { hasPermission, onFailedInteraction } = useCheckPermissions(PERMISSIONS.ORDER_SETTINGS_MANAGEMENT);

    const { t } = useTranslation();
    return <Paper style={{ padding: '2rem', marginBottom: '1.5625rem' }}>
        {title && <FormTitle title={t(title!)} subtitle={subTitle ? t(subTitle) : undefined} />}
        <DynamicForm 
            formData={formData} 
            formRows={formRows}
            disableAll={!hasPermission}
            disableAllInteraction={onFailedInteraction}
            formKeyName={"pickup"} onHandleSubmit={handleSubmit}
            disabledFields={FormPermissions["profile"]}
            subscriptionKey={subscription}
            useFormOptions={{ resolver, mode: "onChange", reValidateMode: "onChange" }}
            formButtons={{
                leftButton: formButtonText ? 
                    { 
                        label: t(formButtonText), 
                        type: "submit", 
                        color: EColourPanel.PRIMARY, 
                        disabled: isLoading || !hasPermission
                    } : undefined,
                rightButtonCustomClassName: rightButtonCustomClassName,
                leftButtonCustomClassName: leftButtonCustomClassName
            }} />
    </Paper>
}